<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            v-on="on"
            @click="sendGADataLayer('delete-account')"
          >
            <div class="list-item-text">
              <span class="list-item-name">Delete my account</span>
            </div>
          </v-btn>
        </div>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Delete account</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p>
            By deleting your account you will remove all information
            {{ whitelabel.name }} has ever stored of you. You will no longer be
            able to edit / update your information or your will.
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-btn
            rounded
            depressed
            :loading="buttonLoading"
            color="primary"
            class="ml-4 mb-1"
            @click="deleteTestator()"
            ><span>Yes, delete</span
            ><v-icon small>{{ icons.mdiArrowRight }}</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { DELETE_TESTATOR_MUTATION } from '../../constants/graphql/testators';

  export default {
    name: 'DeleteAccount',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        dialog: false,
      };
    },
    methods: {
      sendGADataLayer(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: event,
          omuserid: this.$store.getters?.userId,
        });
      },
      deleteTestator() {
        this.sendGADataLayer('delete-account-yes');
        this.buttonLoading = true;
        const id = this.testatorId;

        this.$apollo
          .mutate({
            mutation: DELETE_TESTATOR_MUTATION,
            variables: {
              id,
            },
          })
          .then(response => {
            if (response.data.deleteTestator.success) {
              this.logout();
            } else {
              this.displayErrorAndCloseDialog();
            }
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      logout() {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/');
        });
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
